import { BarChart, type BarSeries } from '@mui/x-charts/BarChart';

import SpinnerLoader from '../Loaders/SpinnerLoader';

import type { BarChartComponentProps, ChartValues, PanelData } from '@/types/monitoringTypes';

const BarChartComponent = ({ panelInfo, height, isLoading, panelData }: BarChartComponentProps) => {
  const getPanelValues = (data?: PanelData): ChartValues => {
    if (!data) {
      return { xAxis: [], series: [] };
    }

    const refIds = panelInfo.targets?.filter(target => !target.hide).map(target => target.refId);
    const frames = refIds
      ?.filter((refId): refId is string => refId !== undefined)
      .map(refId => data.results[refId]?.frames[0]);

    const xAxisIndex = frames?.[0]?.schema?.fields.findIndex(field => field.name === 'coop_model');
    const xAxis: unknown[] =
      xAxisIndex !== undefined && xAxisIndex >= 0
        ? (frames?.[0]?.data.values[xAxisIndex] as unknown[])
        : (frames?.[0]?.data.values[0] as unknown[]);

    const seriesIndex = frames?.[0]?.schema?.fields.findIndex(field => field.type === 'number');
    const series = frames?.map(frame => ({
      data:
        frame?.data.values[typeof seriesIndex === 'number' && seriesIndex >= 0 ? seriesIndex : 1] ??
        [],
      label:
        seriesIndex !== undefined && seriesIndex >= 0 && frame?.schema?.fields[seriesIndex]
          ? frame.schema.fields[seriesIndex].name
          : 'Unknown',
      scaleType: 'band' as const,
    }));

    return {
      xAxis: [{ data: xAxis, scaleType: 'band' as const }],
      series: series as BarSeries[],
    };
  };

  const values = getPanelValues(panelData);

  return (
    <SpinnerLoader
      isLoading={isLoading}
      height={height}
      labelText='Loading Bar Chart...'
    >
      <BarChart
        hideLegend
        series={values.series}
        colors={['#E20074', '#f399c7']}
        xAxis={values.xAxis}
        grid={{ horizontal: true }}
        height={height}
      />
    </SpinnerLoader>
  );
};

export default BarChartComponent;
